var map = {
	"./Abonadora_de_granulado_con_ruedas/1.jpeg": 2744,
	"./Abonadora_de_granulado_con_ruedas/2.jpeg": 3144,
	"./Abonadora_de_granulado_con_ruedas/3.jpeg": 378,
	"./Abonadora_de_granulado_con_ruedas/4.jpeg": 7616,
	"./Abonadora_de_granulado_mochila/1.jpeg": 3786,
	"./Abonadora_de_granulado_mochila/2.jpeg": 4210,
	"./Abonadora_de_granulado_mochila/3.jpeg": 2937,
	"./Abonadora_de_granulado_mochila/4.jpeg": 1267,
	"./Abonadora_tipo_bolsa/1.jpeg": 4642,
	"./Abonadora_tipo_bolsa/2.jpeg": 4665,
	"./Abonadora_tipo_bolsa_con_dos_mangueras/1.jpeg": 8276,
	"./Abonadora_tipo_bolsa_con_dos_mangueras/2.jpeg": 4678,
	"./Abonadoras_de_granulado/1.jpeg": 3188,
	"./Abonadoras_de_granulado/2.jpeg": 8406,
	"./Abonadoras_de_granulado/3.jpeg": 2611,
	"./Abonadoras_de_granulado/4.jpeg": 3030,
	"./Ahoyadora_con_carretilla/1.jpeg": 5496,
	"./Ahoyadora_con_carretilla/2.jpeg": 946,
	"./Aspersor_de_agua/1.jpeg": 2487,
	"./Aspersor_de_agua/2.jpeg": 7386,
	"./Aspersor_de_agua/3.jpeg": 6863,
	"./Aspersor_de_agua/4.jpeg": 5262,
	"./Aspersor_de_agua/5.jpeg": 997,
	"./Aspersor_de_agua/6.jpeg": 5446,
	"./Bomba_de_agua_de_precisión/1.jpeg": 2157,
	"./Bomba_de_agua_de_precisión/2.jpeg": 5505,
	"./Bomba_de_agua_de_precisión/3.jpeg": 7141,
	"./Bomba_de_agua_de_precisión/4.jpeg": 9095,
	"./Bomba_de_agua_de_precisión/5.jpeg": 3908,
	"./Bomba_de_fumigar/1.jpeg": 9792,
	"./Bomba_de_fumigar/2.jpeg": 1169,
	"./Bomba_de_fumigar/3.jpeg": 8192,
	"./Bomba_de_fumigar/4.jpeg": 4525,
	"./Bomba_de_fumigar_manual/1.jpeg": 1661,
	"./Bomba_de_fumigar_manual/2.jpeg": 2298,
	"./Bomba_de_fumigar_manual/3.jpeg": 5519,
	"./Bomba_de_fumigar_manual/4.jpeg": 3252,
	"./Bomba_de_fumigar_manual/5.jpeg": 2062,
	"./Bomba_de_fumigar_manual/6.jpeg": 4203,
	"./Bomba_de_fumigar_manual/7.jpeg": 6537,
	"./Bomba_de_fumigar_manual/8.jpeg": 2535,
	"./Desgranadora/1.jpeg": 7511,
	"./Desgranadora/2.jpeg": 9940,
	"./Desgranadora/3.jpeg": 7514,
	"./Desgranadora/4.jpeg": 1679,
	"./Desgranadora_Maiz/1.jpeg": 3643,
	"./Desgranadora_Maiz/2.jpeg": 43,
	"./Desgranadora_Maiz/3.jpeg": 9733,
	"./Desgranadora_Maiz/4.jpeg": 7750,
	"./Desgranadora_de_Maíz_con_motor/1.jpeg": 3502,
	"./Desgranadora_de_Maíz_con_motor/2.jpeg": 652,
	"./Desgranadora_de_Maíz_con_motor/3.jpeg": 871,
	"./Desgranadora_de_Maíz_con_motor/4.jpeg": 3160,
	"./Desgranadora_de_Maíz_manual/1.jpeg": 9315,
	"./Desgranadora_de_Maíz_manual/2.jpeg": 3677,
	"./Desgranadora_de_Maíz_manual/3.jpeg": 6565,
	"./Desgranadora_de_Maíz_manual_con_Base/1.jpeg": 897,
	"./Desgranadora_de_Maíz_manual_con_Base/2.jpeg": 5423,
	"./Desgranadora_de_Maíz_manual_con_Base/3.jpeg": 1120,
	"./Desgranadora_de_Maíz_manual_con_Base/4.jpeg": 5456,
	"./Desgranadoras_de_Maiz_doble_rodo/1.jpeg": 6153,
	"./Desgranadoras_de_Maiz_doble_rodo/2.jpeg": 5797,
	"./Desgranadoras_de_Maiz_doble_rodo/3.jpeg": 3346,
	"./Desgranadoras_de_Maíz_eléctricas/1.jpeg": 2255,
	"./Desgranadoras_de_Maíz_eléctricas/2.jpeg": 4925,
	"./Desgranadoras_de_Maíz_eléctricas/3.jpeg": 7157,
	"./Esparcidor_de_Semillas/1.jpeg": 7570,
	"./Esparcidor_de_Semillas/2.jpeg": 8001,
	"./Esparcidor_de_Semillas/3.jpeg": 2707,
	"./Esparcidor_de_Semillas/4.jpeg": 6346,
	"./Esparcidor_semillas_de_mochila/1.jpeg": 4606,
	"./Esparcidor_semillas_de_mochila/2.jpeg": 4304,
	"./Esparcidor_semillas_de_mochila/3.jpeg": 224,
	"./Esparcidor_semillas_de_mochila/4.jpeg": 5574,
	"./Generador_de_Diesel/1.jpeg": 4040,
	"./Generador_de_Diesel/2.jpeg": 8432,
	"./Generador_de_Diesel/3.jpeg": 1770,
	"./Generador_de_Diesel/4.jpeg": 2579,
	"./Manguera_de_agua/1.jpeg": 828,
	"./Manguera_de_agua/2.jpeg": 5497,
	"./Molino_Nixtamal/1.jpeg": 115,
	"./Molino_Nixtamal/2.jpeg": 2756,
	"./Molino_Nixtamal/3.jpeg": 5157,
	"./Molino_Nixtamal/4.jpeg": 9985,
	"./Molino_de_Maíz_eléctrico/1.jpeg": 7700,
	"./Molino_de_Maíz_eléctrico/2.jpeg": 9473,
	"./Motobomba/1.jpeg": 3756,
	"./Motobomba/2.jpeg": 8703,
	"./Motobomba/3.jpeg": 1734,
	"./Motobomba/4.jpeg": 7331,
	"./Motocultivador/1.jpeg": 7617,
	"./Motocultivador/2.jpeg": 7912,
	"./Motocultivador/3.jpeg": 5991,
	"./Motocultivador/4.jpeg": 8056,
	"./Motocultivador_de_Dientes/1.jpeg": 6865,
	"./Motocultivador_de_Dientes/2.jpeg": 6583,
	"./Motocultivador_de_Dientes/3.jpeg": 5537,
	"./Motocultivador_de_Dientes/4.jpeg": 9088,
	"./Motor_a_Gasolina/1.jpeg": 8060,
	"./Motor_a_Gasolina/2.jpeg": 6908,
	"./Motor_a_Gasolina/3.jpeg": 4355,
	"./Motor_a_Gasolina/4.jpeg": 3232,
	"./Motor_a_Gasolina/5.jpeg": 1298,
	"./Motosierra/1.jpeg": 7221,
	"./Motosierra/2.jpeg": 9909,
	"./Motosierra/3.jpeg": 8080,
	"./Motosierra/4.jpeg": 3712,
	"./Peletizadora/1.jpeg": 5715,
	"./Peletizadora/2.jpeg": 1474,
	"./Peletizadora/3.jpeg": 2893,
	"./Peletizadora/4.jpeg": 8239,
	"./Peletizadora/5.jpeg": 7810,
	"./Peletizadora_Diesel/1.jpeg": 9651,
	"./Peletizadora_Diesel/2.jpeg": 4650,
	"./Peletizadora_Diesel/3.jpeg": 2086,
	"./Peletizadora_Diesel/4.jpeg": 8748,
	"./Picadora/1.jpeg": 5307,
	"./Picadora/2.jpeg": 6866,
	"./Picadora/3.jpeg": 6904,
	"./Picadora_y_Ensiladora/1.jpeg": 5428,
	"./Picadora_y_Ensiladora/2.jpeg": 7924,
	"./Picadora_y_Ensiladora/3.jpeg": 3654,
	"./Picadora_y_Ensiladora/4.jpeg": 7218,
	"./Rotavitor/1.jpeg": 5462,
	"./Rotavitor/2.jpeg": 6189,
	"./Rotavitor/3.jpeg": 9278,
	"./Rotavitor/4.jpeg": 5533,
	"./Sembradora_de_Maíz_con_motor/1.jpeg": 3052,
	"./Sembradora_de_Maíz_con_motor/2.jpeg": 2468,
	"./Sembradora_de_Maíz_con_motor/3.jpeg": 9557,
	"./Sembradora_de_Maíz_con_motor/4.jpeg": 2773,
	"./Sembradoras_Manuales/1.jpeg": 5128,
	"./Sembradoras_Manuales/2.jpeg": 254,
	"./Sembradoras_Manuales/3.jpeg": 9847,
	"./Sembradoras_Manuales/4.jpeg": 9270,
	"./Sembradoras_Manuales/5.jpeg": 6402,
	"./Sembradoras_Manuales/6.jpeg": 2239,
	"./Sembradoras_Manuales/7.jpeg": 6745,
	"./Sembradoras_Push/1.jpeg": 7799,
	"./Sembradoras_Push/2.jpeg": 2274,
	"./Sembradoras_Push/3.jpeg": 33,
	"./Sembradoras_Push/4.jpeg": 2023,
	"./Sembradoras_Push/5.jpeg": 7847,
	"./Sembradoras_Push/6.jpeg": 1939,
	"./Sembradoras_Push/7.jpeg": 5933,
	"./Sembradoras_Push/8.jpeg": 5367,
	"./Sembradoras_de_Hortalizas_con_Motor/1/1.jpeg": 3754,
	"./Sembradoras_de_Hortalizas_con_Motor/3/1.jpeg": 835,
	"./Sembradoras_de_Hortalizas_con_Motor/3/2.jpeg": 2074,
	"./Sembradoras_de_Hortalizas_con_Motor/3/3.jpeg": 2842,
	"./Sembradoras_de_Hortalizas_con_Motor/3/4.jpeg": 7568,
	"./Sembradoras_de_Hortalizas_con_Motor/4/1.jpeg": 8825,
	"./Sembradoras_de_Hortalizas_con_Motor/4/2.jpeg": 568,
	"./Sembradoras_de_Hortalizas_con_Motor/4/3.jpeg": 6064,
	"./Sembradoras_de_Hortalizas_con_Motor/4/4.jpeg": 8996,
	"./Sembradoras_de_Hortalizas_con_Motor/5/1.jpeg": 58,
	"./Sembradoras_de_Hortalizas_con_Motor/5/2.jpeg": 9057,
	"./Sembradoras_de_Hortalizas_con_Motor/5/3.jpeg": 7843,
	"./Sembradoras_de_Hortalizas_con_Motor/5/4.jpeg": 736,
	"./Sembradoras_de_Pilon/1.jpeg": 3831,
	"./Sembradoras_de_Pilon/2.jpeg": 9355,
	"./Sembradoras_de_Pilon/3.jpeg": 6352,
	"./Sembradoras_de_Pilon/4.jpeg": 1928,
	"./Sembradoras_de_Pilon/5.jpeg": 6306,
	"./Sembradoras_de_Pilon/6.jpeg": 2462,
	"./Sembradoras_de_Pilon/7.jpeg": 8391,
	"./Sembradoras_de_Pilon/8.jpeg": 7051,
	"./Sembradoras_de_Pilon/9.jpeg": 190,
	"./Surqueador/1.jpeg": 219,
	"./Surqueador/2.jpeg": 4124,
	"./Surqueador/3.jpeg": 5377,
	"./Surqueador/4.jpeg": 8255,
	"./Taladro/1.jpeg": 5543,
	"./Taladro/2.jpeg": 5221,
	"./Taladro/3.jpeg": 2544,
	"./Taladro/4.jpeg": 8375,
	"./Taladro/5.jpeg": 6957,
	"./Taladro_de_concreto_eléctrico/1.jpeg": 6679,
	"./Termonebulizadora/1.jpeg": 8465,
	"./Termonebulizadora/2.jpeg": 6423,
	"./Trípode_para_Aspersor_de_agua/1.jpeg": 3989,
	"./Trípode_para_Aspersor_de_agua/2.jpeg": 8183,
	"./Trípode_para_Aspersor_de_agua/3.jpeg": 2491,
	"./Trípode_para_Aspersor_de_agua/4.jpeg": 1140,
	"./Trípode_para_Aspersor_de_agua/5.jpeg": 270,
	"./Trípode_para_Aspersor_de_agua/6.jpeg": 5363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;